import React from 'react';

import './recover_password.css';
import logoPretzu from '../../assets/logos_pretzu/logo_login.svg';


export const MessageRecoverPassword = () => {
    return (
        <div className='container'>
            <div className='row d-flex justify-content-center ContainerLogin'>

                <div className="col-md-5">

                    <div className='row'>
                        <div className="col text-center">
                            <img src={logoPretzu} alt="logo pretzu" />
                        </div>
                    </div>

                    <div className='row m-3'>
                        <div className="col text-center p-content-title-recover-password">
                            <h1 className='p-title-recover-password'>¡HOLA ZULAY!</h1>
                        </div>
                    </div>

                    {/* <div className='row m-3'>
                        <div className="col text-center">
                            <h5 className='p-text-recover-password-two text-uppercase fw-bold'>Ingresa tu nueva contraseña.</h5>
                        </div>
                    </div> */}

                    <div className='login m-4'
                    >
                        <div className=" justify-content-center p-2">
                            <div className="text-center">
                                <h5 className='fs-6 pb-4'>Haz click aquí para cambiar tu contraseña en Pretzu</h5>
                            </div>
                            <div className="d-grid col-12 mx-auto">
                                <button type="button" className="btn btn-primary" style={{backgroundColor: '#8E24AA', color: 'white', borderColor:'#8E24AA'}}
                                //onClick={handleClose}
                                >Cambiar contraseña
                                </button>
                            </div>

                            <div className=" justify-content-center">

                                <p className='text-center p-4'>
                                    Si tú no pediste el cambio, ignora este mensaje.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
